import { Box, IconButton } from '@wix/design-system';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import { useRef, useState, useEffect } from 'react';


import css from './index.module.scss';

type RelatedQuestionsSliderProps = {
  relatedQuestions: string[];
  onQuestionClick?: (question: string) => void;
};

export const RelatedQuestionsSlider = ({
  relatedQuestions,
  onQuestionClick,
}: RelatedQuestionsSliderProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const [hasOverflow, setHasOverflow] = useState(false);

  const checkOverflow = () => {
    const el = containerRef.current;
    if (!el) {return; }
    setHasOverflow(el.scrollWidth > el.clientWidth + 1);
  };

  useEffect(() => {
    checkOverflow();
  }, [relatedQuestions]);

  const toggle = () => {
    const el = containerRef.current;
    if (!el) {return; }
    const goToEnd = isAtStart;
    el.scrollTo({
      left: goToEnd ? el.scrollWidth - el.clientWidth : 0,
      behavior: 'smooth',
    });
    setIsAtStart(!isAtStart);
  };

  return (
    <Box className={css.wrapper}>
      {!isAtStart && hasOverflow && (
        <IconButton className={css.arrowButton} onClick={toggle} size="tiny" skin="dark" priority="secondary">
          <ChevronLeft />
        </IconButton>
      )}
      <div
        className={css.sliderContainer}
        ref={containerRef}
      >
        {relatedQuestions.map((question) => (
          <button
            key={question}
            className={css.tag}
            onClick={() => onQuestionClick?.(question)}
          >
            {question}
          </button>
        ))}
      </div>
      {isAtStart && hasOverflow && (
        <IconButton className={css.arrowButton} onClick={toggle} size="tiny" skin="dark" priority="secondary">
          <ChevronRight />
        </IconButton>
      )}
    </Box>
  );
};
